import { makeStyles } from '@material-ui/core/styles';

import { neutral, orange, red, teal } from 'shared/styles/colors';

export default makeStyles({
  card: {
    padding: '0.5rem 1rem',
    borderTop: `1px solid ${neutral[30]}`,
    '&[data-seen="false"]': {
      '&:hover': {
        cursor: 'crosshair',
        backgroundColor: neutral[20],
        borderRadius: '0.5rem',
        border: `1px solid ${neutral[30]}`,
      },
    },
    '&[data-seen="true"]': {
      cursor: 'text',
    },
  },
  header: {
    display: 'flex',
    gap: '0.5rem',
    alignItems: 'center',
  },
  title: {
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
  },
  checkMark: {
    height: '0.5rem',
    width: '0.5rem',
    borderRadius: '50%',
    backgroundColor: red[50],
    '[data-seen="true"] &': {
      backgroundColor: teal[20],
    },
  },
  description: {
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: '1.125rem',
  },
  dateTime: {
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: '1.25rem',
    color: orange[70],
    '[data-seen="true"] &': {
      color: teal[70],
    },
  },
});
